import app from 'flarum/forum/app';
const OVERLAY_ID = 'umiteski-sso-redirect-overlay';
const STYLE_ID = 'umiteski-sso-redirect-styles';
function ensureKeyframes() {
  if (document.getElementById(STYLE_ID)) {
    return;
  }
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `@keyframes umiteski-sso-spin{to{transform:rotate(360deg)}}`;
  document.head.appendChild(style);
}
export function removeSsoRedirectOverlay() {
  document.getElementById(OVERLAY_ID)?.remove();
}

/**
 * Ana site / OAuth yönlendirmesinden hemen önce kısa süreli kart gösterir; iki rAF ile boyama şansı verilir.
 */
export function redirectWithSsoOverlay(url, mode) {
  removeSsoRedirectOverlay();
  ensureKeyframes();
  const titleKey = mode === 'login' ? 'umiteski-sso.forum.redirect.login_title' : 'umiteski-sso.forum.redirect.register_title';
  const hintKey = mode === 'login' ? 'umiteski-sso.forum.redirect.login_hint' : 'umiteski-sso.forum.redirect.register_hint';
  const overlay = document.createElement('div');
  overlay.id = OVERLAY_ID;
  overlay.setAttribute('role', 'status');
  overlay.setAttribute('aria-live', 'polite');
  overlay.style.cssText = ['position:fixed', 'inset:0', 'z-index:2147483646', 'display:flex', 'align-items:flex-start', 'justify-content:center', 'padding:24px 16px', 'box-sizing:border-box', 'font-family:system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif', '-webkit-font-smoothing:antialiased'].join(';');
  const backdrop = document.createElement('div');
  backdrop.setAttribute('aria-hidden', 'true');
  backdrop.style.cssText = ['position:absolute', 'inset:0', 'background:rgba(15,23,42,0.4)', 'backdrop-filter:blur(8px)'].join(';');
  const card = document.createElement('div');
  card.style.cssText = ['position:relative', 'z-index:1', 'max-width:400px', 'width:100%', 'margin-top:12vh', 'padding:28px 24px 26px', 'border-radius:16px', 'background:#fff', 'color:#0f172a', 'box-shadow:0 25px 50px -12px rgba(15,23,42,0.35),0 0 0 1px rgba(15,23,42,0.06)', 'text-align:center'].join(';');
  if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    card.style.background = '#1e293b';
    card.style.color = '#f1f5f9';
    card.style.boxShadow = '0 25px 50px -12px rgba(0,0,0,0.55),0 0 0 1px rgba(255,255,255,0.06)';
  }
  const spinner = document.createElement('div');
  spinner.setAttribute('aria-hidden', 'true');
  const spinTop = window.matchMedia('(prefers-color-scheme: dark)').matches ? '#60a5fa' : '#2b74b2';
  spinner.style.cssText = ['width:44px', 'height:44px', 'margin:0 auto 18px', 'border-radius:50%', 'border:3px solid rgba(43,116,178,0.22)', `border-top-color:${spinTop}`, 'animation:umiteski-sso-spin 0.75s linear infinite'].join(';');
  const title = document.createElement('p');
  title.style.cssText = 'margin:0 0 10px;font-size:1.125rem;font-weight:600;line-height:1.35;letter-spacing:-0.02em';
  title.textContent = String(app.translator.trans(titleKey));
  const hint = document.createElement('p');
  hint.style.cssText = 'margin:0;font-size:0.9375rem;line-height:1.5;color:#64748b';
  hint.textContent = String(app.translator.trans(hintKey));
  if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    hint.style.color = '#94a3b8';
  }
  card.appendChild(spinner);
  card.appendChild(title);
  card.appendChild(hint);
  overlay.appendChild(backdrop);
  overlay.appendChild(card);
  document.body.appendChild(overlay);
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      window.location.assign(url);
    });
  });
}